export const popupCenter = (url, title, w, h) => {
  const { screen } = window;
  const dualScreenLeft = window.screenLeft ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop ? window.screenTop : window.screenY;

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth || screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight || screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = ((width - w) / 2 / systemZoom) + dualScreenLeft;
  const top = ((height - h) / 2 / systemZoom) + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    `scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`
  );

  if (window.focus) newWindow.focus();
};

function isOS() {
  return navigator.userAgent.match(/ipad|iphone/i);
}

export const copyToBuffer = content => {
  let range;
  let selection;
  const TEST_ID = 'clipboard';
  let el = document.querySelector(`textarea[data-testid="${TEST_ID}"]`);
  if (!el) {
    el = document.createElement('textarea');
    el.dataset.testid = TEST_ID;
    document.body.appendChild(el);
  }
  el.value = content;

  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';

  if (isOS()) {
    range = document.createRange();
    range.selectNodeContents(el);
    selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    el.setSelectionRange(0, 999999);
  } else {
    el.select();
  }
  document.execCommand('copy');
};
